<script setup lang="ts">
import { ChatPage } from '@/functions/inquiry/views';
import { ARTICLE_SEO_SITE_NAME, SEO_COMMON_DESCRIPTION } from '@/utils/articleSeo';

import { useSeoMeta, useHead } from '#imports';

useSeoMeta({
  title: 'dスマホローンチャットサービスについて| dスマホローン | カードがいらないドコモのカードローン',
  description:
    'dスマホローンのお問い合わせ窓口をご案内します。' +
    SEO_COMMON_DESCRIPTION +
    'カードがいらないカードローン。お申込みからご契約、お借入れ・ご返済もスマホにて完結。書類の郵送や来店も不要です。',
  keywords: 'dスマホローン,ドコモ,問い合わせ',
  ogUrl: 'https://loan.docomo.ne.jp/inquiry/chat/',
  ogType: 'article',
  ogTitle: 'dスマホローンチャットサービスについて | dスマホローン | カードがいらないドコモのカードローン',
  ogDescription:
    'dスマホローンのお問い合わせ窓口をご案内します。' +
    SEO_COMMON_DESCRIPTION +
    'カードがいらないカードローン。お申込みからご契約、お借入れ・ご返済もスマホにて完結。書類の郵送や来店も不要です。',
  ogSiteName: ARTICLE_SEO_SITE_NAME,
  ogImage: 'https://loan.docomo.ne.jp/img/ogp.png',
});

useHead({
  link: [
    {
      rel: 'canonical',
      href: 'https://loan.docomo.ne.jp/inquiry/chat/',
    },
    {
      rel: 'icon',
      href: '/img/favicon.ico',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: '/img/android-chrome-192x192.png',
    },
    {
      rel: 'apple-touch-icon',
      href: '/img/apple-touch-icon.png',
    },
  ],
});
</script>

<template>
  <ChatPage />
</template>
